export const formatNotamCoordinates = (lat: number, lon: number) => {
  const ns = lat < 0 ? 'S' : 'N';
  const ew = lon < 0 ? 'W' : 'E';

  const absLat = Math.abs(lat);
  const absLon = Math.abs(lon);

  const degLat = Math.floor(absLat);
  const degLon = Math.floor(absLon);
  const minLat = Math.round((absLat - degLat) * 60);
  const minLon = Math.round((absLon - degLon) * 60);

  const strLat = `${degLat.toFixed(0).padStart(2, '0')}${minLat.toFixed(0).padStart(2, '0')}`;
  const strLon = `${degLon.toFixed(0).padStart(3, '0')}${minLon.toFixed(0).padStart(2, '0')}`;
  return `${ns}${strLat} ${ew}${strLon}`;
};
